export const DESKTOP = 'desktop' as const;
export const MOBILE = 'mobile' as const;
export const TABLET = 'tablet' as const;

export type DEVICE_TYPES = typeof DESKTOP | typeof MOBILE | typeof TABLET;

export const isDeviceType = (deviceType: unknown): deviceType is DEVICE_TYPES => {
    return deviceType === DESKTOP || deviceType === MOBILE || deviceType === TABLET;
};
